import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/verify-email-pending";
import { buildNoindexHead } from "@/lib/noindex-seo";

export const Route = createFileRoute("/verify-email-pending")({
  head: () => buildNoindexHead("Check Your Inbox", "/verify-email-pending"),
  component: Page,
});
